module.exports = __webpack_public_path__ + "assets/69c315a1b647ab8fb51ebf9c8f9b3c4f.jpg";